import {
    Directive,
    Input,
    Renderer2,
    ElementRef,
    OnChanges,
    SimpleChanges,
    inject
} from "@angular/core";

@Directive({
    selector: "[decorate]",
    standalone: false
})
export class DecorateTextDirective implements OnChanges {
    private _elementRef = inject(ElementRef);
    private _renderer = inject(Renderer2);
    @Input() decorate: string;
    @Input() decoratedPart: string;
    @Input() decoratingClass: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.decorate && changes.decoratedPart && changes.decoratingClass) {
            const textParts = this.decorate.split(new RegExp(this.decoratedPart, "i"));
            if (textParts.length > 1) {
                if (this.decorate.indexOf(this.decoratedPart) === 0) {
                    this._createDecoratedSpan(true);
                }
                textParts.forEach((value, index) => {
                    const ordinaryPart = this._renderer.createText(value);
                    this._renderer.appendChild(this._elementRef.nativeElement, ordinaryPart);
                    if (index < textParts.length - 1) {
                        this._createDecoratedSpan(false);
                    }
                });
            }
        }
    }

    private _createDecoratedSpan(isLeading: boolean): void {
        const decoratedElement = this._renderer.createElement("span");
        const decoratedText = this._renderer.createText(
            isLeading
                ? this.decoratedPart[0].toUpperCase() + this.decoratedPart.substring(1)
                : this.decoratedPart.toLowerCase()
        );
        this._renderer.appendChild(decoratedElement, decoratedText);
        this._renderer.addClass(decoratedElement, this.decoratingClass);
        this._renderer.appendChild(this._elementRef.nativeElement, decoratedElement);
    }
}
